import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

export default function Profile() {
  const user = JSON.parse(localStorage.getItem("user"));
  const isSupervisor = user.groupId === "     9";
  const { t, switchLanguage, language } = useLanguage();
  return (
    <div className="max-w-6xl mx-auto mt-24 px-4">

      {/* HEADER */}
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-800">
          {t.menuMyAccount}
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Gestiona tu información, seguridad y preferencias
        </p>
      </div>

      {/* SECCIÓN PRINCIPAL */}
      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">

        {/* PERFIL */}
        <Link
          to="/profile/personal"
          className="group bg-white border rounded-xl p-6 hover:shadow-md transition"
        >
          <h3 className="font-medium text-gray-800 mb-1">
            Perfil personal
          </h3>
          <p className="text-sm text-gray-500">
            Datos básicos de tu usuario
          </p>
        </Link>

        {/* EMPRESA */}
        <Link
          to="/profile/ProfileCompany"
          className="group bg-white border rounded-xl p-6 hover:shadow-md transition"
        >
          <h3 className="font-medium text-gray-800 mb-1">
            Empresa / Cuenta
          </h3>
          <p className="text-sm text-gray-500">
            Información de tu empresa y sucursal
          </p>
        </Link>


        {/* SEGURIDAD */}
        <Link
          to="/profile/security"
          className="hidden group bg-white border rounded-xl p-6 hover:shadow-md transition"
        >
          <h3 className="font-medium text-gray-800 mb-1">
            Seguridad
          </h3>
          <p className="text-sm text-gray-500">
            Contraseña y control de acceso
          </p>
        </Link>

        {/* PREFERENCIAS */}
        <Link
          to="/profile/preferences"
          className="hidden group bg-white border rounded-xl p-6 hover:shadow-md transition"
        >
          <h3 className="font-medium text-gray-800 mb-1">
            Preferencias
          </h3>
          <p className="text-sm text-gray-500">
            Idioma, notificaciones y UI
          </p>
        </Link>

      </section>

      {/* SECCIÓN SUPERVISOR */}
      {isSupervisor && (
        <>
          <div className="border-t pt-8 mb-4">
            <h2 className="text-lg font-semibold text-gray-800">
              Opciones de Supervisor
            </h2>
            <p className="text-sm text-gray-500">
              Herramientas administrativas avanzadas
            </p>
          </div>

          <section className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* GESTIÓN DE USUARIOS */}
            <Link
              to="/profile/users"
              className="bg-white border border-brand-primary/30 rounded-xl p-6 hover:shadow-md transition"
            >
              <h3 className="font-medium text-gray-800 mb-1">
                Gestión de usuarios
              </h3>
              <p className="text-sm text-gray-500">
                Crear y administrar usuarios operativos
              </p>
            </Link>

            {/* PRESUPUESTOS */}
            <Link
              to="/profile/budget"
              className="bg-white border border-brand-primary/30 rounded-xl p-6 hover:shadow-md transition"
            >
              <h3 className="font-medium text-gray-800 mb-1">
                Presupuestos
              </h3>
              <p className="text-sm text-gray-500">
                Asignar y editar presupuesto mensual por sede y categoría
              </p>
            </Link>

            {/* FUTURO */}
            <div className="hidden bg-gray-50 border rounded-xl p-6 text-gray-400 cursor-not-allowed">
              <h3 className="font-medium mb-1">
                Auditoría
              </h3>
              <p className="text-sm">
                Próximamente
              </p>
            </div>

          </section>
        </>
      )}

    </div>
  );
}
